import type { Cache } from '@urql/exchange-graphcache';
import { QUERY_ROOT_NAME } from './constants';

export type FieldInvalidationCache = Pick<
  Cache,
  'inspectFields' | 'invalidate'
>;

export default function invalidateFields(
  fieldNames: string[],
  cache: FieldInvalidationCache,
) {
  const fieldNameSet = new Set(fieldNames);
  const allFields = cache.inspectFields(QUERY_ROOT_NAME);

  for (const field of allFields) {
    if (fieldNameSet.has(field.fieldName)) {
      cache.invalidate(QUERY_ROOT_NAME, field.fieldKey);
    }
  }
}
